/**
 * used to transform the ba object
 *
 * @param success tells whether card is validated or not
 * @param message message in case of validation
 * @returns {
        success: success,
        message: message,
        data: data,
    }
 *
 */

const validateBankCardTransformer = ({ message, data, success }: ValidateBankCardTransformerType) => ({
    success: success || true,
    message: message || '',
    data: data || true,
  });

  export default validateBankCardTransformer;
